export enum Module {
  TERMINAL = 'Terminal',
  ACTIVITIES = 'Activities',
  TIMESHEETS = 'Timesheets',
  VEHICLES = 'Vehicles',
  HANDBOOK = 'Handbook',
  ISSUES = 'Issues',
  FORUM = 'Forum',
  ABSENCES = 'Absences',
  INFRINGEMENTS = 'Infringements',
  WORK_DAY_INFRINGEMENTS = 'WorkInfringements',
  ROUTEPLANNER = 'RoutePlanner',
  FLEET = 'Fleet',
  PLANNER = 'Planner',
  SALARY = 'Salary',
  FORMCREATOR = 'FormCreator',
  USERS = 'Users',
}

export const ALL_MODULES = Object.values(Module)

export const LEADER_GROUP_RESTRICTABLE_MODULES = [
  Module.ACTIVITIES,
  Module.ISSUES,
  Module.FORUM,
  Module.ABSENCES,
  Module.INFRINGEMENTS,
  Module.TIMESHEETS,
] as const

//This "duplicate" enum exists for use in UserExport module field
export enum ModuleName {
  ABSENCES = 'ABSENCES',
  ACTIVITIES = 'ACTIVITIES',
  FLEET = 'FLEET',
  FORMCREATOR = 'FORMCREATOR',
  FORUM = 'FORUM',
  HANDBOOK = 'HANDBOOK',
  INFRINGEMENTS = 'INFRINGEMENTS',
  ISSUES = 'ISSUES',
  ROUTEPLANNER = 'ROUTE_PLANNER',
  SALARY = 'SALARY',
  TERMINAL = 'TERMINAL',
  TIMESHEETS = 'TIMESHEETS',
  VEHICLES = 'VEHICLES',
  USERS = 'USERS',
}

export function isModuleName(value: string): value is ModuleName {
  return Object.values(ModuleName).includes(value as ModuleName)
}

export const SalaryModule = {
  ACTIVITIES: Module.ACTIVITIES,
  TIMESHEETS: Module.TIMESHEETS,
  TERMINAL: Module.TERMINAL,
}

export const ModuleAsPermissionPrefixes = {
  TERMINAL: ['terminal'],
  ACTIVITIES: ['activities', 'dynamic_tables'],
  TIMESHEETS: ['timesheets'],
  VEHICLES: ['vehicles'],
  HANDBOOK: ['handbook', 'formcreator'],
  ISSUES: ['issues'],
  FORUM: ['forum'],
  ABSENCES: ['absences'],
  INFRINGEMENTS: ['infringements'],
  WORK_DAY_INFRINGEMENTS: ['infringements'],
  ROUTEPLANNER: ['route_planner'],
  FLEET: ['fleet'],
  PLANNER: ['planner'],
  SALARY: ['salary'],
  OTHER: ['companies', 'users', 'salaryAddons'],
}

export const Integration = {
  VOLVO: 'Volvo',
  SCANIA: 'Scania',
  FLEETBOARD: 'FleetBoard',
  MAN: 'Man',
}

export enum ModuleOptionsValue {
  ACTIVITIES_RECEIPT_FUNCTIONALITY = 'ACTIVITIES_RECEIPT_FUNCTIONALITY',
  TIMESHEETS_OVERTIME_OPTIONS = 'TIMESHEETS_OVERTIME_OPTIONS',
  TIMESHEETS_COUNT_PAUSE_IN_TOTAL = 'TIMESHEETS_COUNT_PAUSE_IN_TOTAL',
  TIMESHEETS_COMMENT_REQUIRED = 'TIMESHEETS_COMMENT_REQUIRED',
  TIMESHEETS_PROJECTS = 'TIMESHEETS_PROJECTS',
  TIMESHEETS_DAY_INTERVAL_OVERTIME = 'TIMESHEETS_DAY_INTERVAL_OVERTIME',
  MERGE_TIMESHEETS_WITH_ACTIVITIES = 'MERGE_TIMESHEETS_WITH_ACTIVITIES',
  TIMESHEETS_DEPARTMENT_SELECT_REQUIRED = 'TIMESHEETS_DEPARTMENT_SELECT_REQUIRED',
  TIMESHEETS_FACILITY_SELECT_REQUIRED = 'TIMESHEETS_FACILITY_SELECT_REQUIRED',
  ISSUES_REQUIRE_SEVERITY = 'ISSUES_REQUIRE_SEVERITY',
  ISSUES_LOCATION_DESCRIPTION_ENABLE = 'ISSUES_LOCATION_DESCRIPTION_ENABLE',
  ISSUES_ACTION_ENABLE_ON_CREATION = 'ISSUES_ACTION_ENABLE_ON_CREATION',
  ISSUES_ESTIMATED_COST_ENABLE_ON_CREATION = 'ISSUES_ESTIMATED_COST_ENABLE_ON_CREATION',
  CREATE_ISSUE_FROM_INFRINGEMENTS = 'CREATE_ISSUE_FROM_INFRINGEMENTS',
  TIMESHEETS_SALARY_CODE_IN_REGISTRATION = 'TIMESHEETS_SALARY_CODE_IN_REGISTRATION',
  INFRINGEMENTS_USER_CAN_CLOSE_OWN_INFRINGEMENT = 'INFRINGEMENTS_USER_CAN_CLOSE_OWN_INFRINGEMENT',
  ACTIVITIES_SIMPLE_DIET_OPTION = 'ACTIVITIES_SIMPLE_DIET_OPTION',
  ACTIVITIES_DIET_COMMENT_MANDATORY = 'ACTIVITIES_DIET_COMMENT_MANDATORY',
  ACTIVITIES_READ_TACHO_FILES_TO_ACTIVITIES = 'ACTIVITIES_READ_TACHO_FILES_TO_ACTIVITIES',
  ACTIVITIES_PROCESS_TACHO_FILES = 'ACTIVITIES_PROCESS_TACHO_FILES',
  // Summary
  ACTIVITIES_SUMMARY_SHOW_PAUSE = 'ACTIVITIES_SUMMARY_SHOW_PAUSE',
  ACTIVITIES_SUMMARY_SHOW_AVAILABILITY_TIME = 'ACTIVITIES_SUMMARY_SHOW_AVAILABILITY_TIME',
  ACTIVITIES_SUMMARY_SHOW_DRIVING = 'ACTIVITIES_SUMMARY_SHOW_DRIVING',
  ACTIVITIES_SUMMARY_SHOW_OTHER_WORK = 'ACTIVITIES_SUMMARY_SHOW_OTHER_WORK',
  ACTIVITIES_SUMMARY_SHOW_TOTAL_OVERTIME = 'ACTIVITIES_SUMMARY_SHOW_TOTAL_OVERTIME',
  SALARY_ONLY_INCLUDE_APPROVED_HOURS = 'SALARY_ONLY_INCLUDE_APPROVED_HOURS',
  SALARY_USER_APPROVE_HOURS = 'SALARY_USER_APPROVE_HOURS',
  SALARY_LEADER_APPROVE_HOURS = 'SALARY_LEADER_APPROVE_HOURS',
  SALARY_ALLOW_TRANSFER_OF_HOURS_TO_ABSENCES = 'SALARY_ALLOW_TRANSFER_OF_HOURS_TO_ABSENCES',
  SALARY_REQUIRE_COMMENT_ON_DRIVER_APPROVAL = 'SALARY_REQUIRE_COMMENT_ON_DRIVER_APPROVAL',
  SALARY_REQUIRE_COMMENT_ON_MANAGER_APPROVAL = 'SALARY_REQUIRE_COMMENT_ON_MANAGER_APPROVAL',
}
